import {Text} from '@/components/atoms'
import {PromotionType} from '@/utils/constants/promotionConstants'
import {BuyMultipleProductsCondition} from './BuyMultipleProductsConditon'
import {BuySingleProductConditions} from './BuySingleProductConditions'
import {RewardDiscount} from './Rewards/RewardDiscount'

const PromotionsConditions = ({condition, promotionType}) => {
  const renderConditionContent = () => {
    switch (promotionType) {
      case PromotionType.BUY_PRODUCT:
        return <BuySingleProductConditions promotionCondition={condition} />
      case PromotionType.STORE_DISCOUNT:
        return (
          <div className="flex items-center gap-4">
            <Text>{'Get'}</Text>
            <RewardDiscount promotionCondition={condition} />
          </div>
        )
      case PromotionType.WELCOME_DISCOUNT:
        return (
          <div className="flex items-center gap-4">
            <Text>{'Get'}</Text>
            <RewardDiscount promotionCondition={condition} textAfterInput="% off, after first order." />
          </div>
        )
      case PromotionType.BUY_MULTIPLE:
        return <BuyMultipleProductsCondition promotionCondition={condition} />
      default:
        return null
    }
  }

  return <div className="flex flex-wrap items-center gap-4 pt-2">{renderConditionContent()}</div>
}

export default PromotionsConditions
